<template>
    <sticky-cta-page :ctaProps=ctaProps :pageBackgroundColor="pageBackgroundColor" @click="$emit('click')">
      <div class="upsell-page" :style="pageStyles">
        <div class="flex-column flex-1 justify-content-center">
          <img :src="imgSrc" class="margin-bottom-l"/>
        </div>
        <div>
          <div class="ri-body margin-bottom-s"> {{ title }} </div>
          <div class="ri-large-headline margin-bottom-xs ri-alte"> {{ headline }} </div>
          <div class="ri-large-body">
            <slot />
          </div>
        </div>
      </div>
    </sticky-cta-page>
</template>

<script>
import StickyCtaPage from './StickyCtaPage';
import Colors from '../scss/riseup-js-colors.module.scss';

export default {
  name: 'UpsellPage',
  components: {
    StickyCtaPage,
  },
  props: {
    pageBackgroundColor: {
      type: String,
      default: Colors.riseupWhite,
    },
    textColor: {
      type: String,
      default: Colors.riseupBlack,
    },
    imgSrc: {
      type: String,
      required: true,
    },
    headline: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    ctaText: {
      type: String,
      required: true,
    },
    ctaButtonProps: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ctaProps() {
      return { buttonProps: { ...this.ctaButtonProps, title: this.ctaText }, backgroundColor: this.pageBackgroundColor };
    },
    pageStyles() {
      return { backgroundColor: this.pageBackgroundColor, color: this.textColor };
    },
  },
};
</script>

<style lang="scss" scoped>

@import '../scss/spacings';

.upsell-page {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: $ri-spacing-m $ri-spacing-ml;

  img {
    width: 100%;
  }
}
</style>
